import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import classNames from 'classnames';
import { Icon } from '../../../';
import NavTooltip from './NavTooltip';

var SidebarExpandToggle = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SidebarExpandToggle, _React$PureComponent);

  var _super = _createSuper(SidebarExpandToggle);

  function SidebarExpandToggle() {
    var _this;

    _classCallCheck(this, SidebarExpandToggle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      var _this$props = _this.props,
          expanded = _this$props.expanded,
          setExpanded = _this$props.setExpanded,
          setExpandedKeys = _this$props.setExpandedKeys;
      e.preventDefault();

      if (expanded) {
        setExpanded(false); // also collapse any expanded submenus

        setExpandedKeys({});
      } else {
        setExpanded(true);
      }
    });

    return _this;
  }

  _createClass(SidebarExpandToggle, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          expanded = _this$props2.expanded,
          inverted = _this$props2.inverted;
      var tooltip = expanded ? 'Collapse' : 'Expand';
      return /*#__PURE__*/React.createElement(NavTooltip, {
        className: classNames('sidebar expand-toggle', {
          expanded: expanded
        }),
        content: tooltip,
        inverted: inverted,
        position: "right center",
        popperDependencies: [tooltip],
        trigger: /*#__PURE__*/React.createElement("button", {
          className: "toggle",
          onClick: this.onClick
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "chevron-right"
        }))
      });
    }
  }]);

  return SidebarExpandToggle;
}(React.PureComponent);

export default SidebarExpandToggle;